declare let AutoNumeric: any;
declare let tinymce: any;
declare let FilePondPluginFileValidateSize: any;
declare let FilePondPluginImagePreview: any;
declare let toastui: any;
declare let Swal: any;

namespace Controlli {
    export namespace Utility {

        export const BodyName: string = "#contenitore-corpo";

        export enum HttpMethod {
            POST = "POST",
            GET = "GET",
            PUT = "PUT",
            DELETE = "DELETE"
        };

        export function BuildDataAttr(baseDataAttr: string, childDataAttr: string, prefixData: boolean = true) {
            let result = "data-"
            if (baseDataAttr && baseDataAttr.trim() !== "") {
                if (!baseDataAttr.startsWith("data") && prefixData) {
                    baseDataAttr = "data-" + baseDataAttr;
                }
                result = baseDataAttr;
            }

            if (childDataAttr && childDataAttr.trim() !== "") {
                result += "-" + childDataAttr;
            }

            return result;
        }

        export function Initialize() {

            (<any>$).datetimepicker.setLocale('it');
            (<any>$).fn.filepond.registerPlugin(FilePondPluginFileValidateSize);
            (<any>$).fn.filepond.registerPlugin(FilePondPluginImagePreview);
            $(document).on("FilePond:addfilestart FilePond:processfilestart FilePond:processfileprogress", function (e: any) {
                let _btn = $("form :submit");

                if (_btn !== null || _btn !== undefined) {
                    if (_btn.length > 0) {
                        _btn.prop("disabled", true);
                    }
                }
            });
            $(document).on("FilePond:addfile FilePond:processfiles FilePond:processfile", function (e: any) {
                let _btn = $("form :submit");

                if (_btn !== null || _btn !== undefined) {
                    if (_btn.length > 0) {
                        _btn.prop("disabled", false);
                    }
                }
            });
            $(document).on("change", "input[type=checkbox]", function () {
                let _this = $(this);
                let _gruppo: string = _this.data("gruppo");

                if (_gruppo !== null) {
                    $(`[data-gruppo-id="${_gruppo}"]`).children().prop("disabled", !_this.is(":checked"));
                    $(`[data-gruppo-id="${_gruppo}"]`).children().val("");
                }
            });

            Overlay.Initialize();
            Modal.Initialize();
            Confirm.Initialize();
            FormAside.Initialize();
            FormAside.InitializeSecondary();

            RefreshControl();
        }

        export function DestroyControl(context?) {
            let _selettore: JQuery = ((context == null) ? $(document) : $(context));

            _selettore.find('[data-tipo="calendario"]').each(function () {
                (<any>$(this)).datetimepicker("destroy");
            });
            _selettore.find('[data-tipo="data"]').each(function () {
                (<any>$(this)).datetimepicker("destroy");
            });
            _selettore.find('[data-tipo="ora"]').each(function () {
                (<any>$(this)).datetimepicker("destroy");
            });
            _selettore.find('[data-tipo="dataora"]').each(function () {
                (<any>$(this)).datetimepicker("destroy");
            });
            _selettore.find('[data-tipo="decimale"]').each(function () {
                $(this).remove();
            });
            _selettore.find('[data-tipo="numerico"]').each(function () {
                $(this).remove();
            });
            _selettore.find('[data-toggle="tooltip"]').each(function () {
                $(this).tooltip("dispose");
            });
            _selettore.find('[data-tipo="switch"]').each(function () {
                (<any>$(this)).bootstrapToggle('destroy');
            });
            _selettore.find('[data-tipo="wysiwyg"]').each(function () {
                (<any>$(this)).summernote('destroy');
            });

            _selettore.find("[data-charm]").each(function () {
                $(this).off("click");
            });

            //Chart remove
            _selettore.find('[data-tipo^="chart"]').each(function () {
                if ($(this).hasClass("apex-chart")) {
                    let idChart = $(this).data("chart-id") as string;
                    $(this).data("chart-Id")
                    ChartsGlobal.DestroyChart(idChart);
                }
            });
        }

        export function RefreshControl(context?) {
            let _selettore: JQuery = ((context == null) ? $(document) : $(context));
            let _settings_ToolTip: JQueryUI.TooltipOptions;

            _selettore.find("[data-modal]").each(function () {
                $(this).on("click", function (e) {
                    e.preventDefault();
                    $(this).tooltip("hide");
                    let _options: Controlli.Modal.ModalOptions = new Controlli.Modal.ModalOptions;

                    _options.Url = $(this).data("modal-url");
                    _options.Titolo = $(this).data("modal-titolo");
                    if ($(this).data("modal-dimensione") != undefined)
                        _options.Dimensione = $(this).data("modal-dimensione");

                    Controlli.Modal.Load(_options);
                });
            });
            _selettore.find("[data-alert]").each(function () {
                $(this).on("click", function (e) {
                    e.preventDefault();
                    $(this).tooltip("hide");
                    let _confirmOptions: Confirm.ConfirmOptions = new Confirm.ConfirmOptions;

                    _confirmOptions.Messaggio = $(this).data("alert-message");
                    _confirmOptions.Url = $(this).data("alert-url");
                    _confirmOptions.OnCompleteFunction = $(this).data("alert-oncomplete");
                    _confirmOptions.TargetID = $(this).data("alert-targetid");
                    _confirmOptions.ReplaceContent = ($(this).data("alert-replace") == undefined) ? false : $(this).data("alert-replace");
                    _confirmOptions.HasEmptyResult = ($(this).data("alert-emptyresult") == undefined) ? false : $(this).data("alert-emptyresult");

                    Swal.fire({
                        title: 'SAV',
                        html: $(this).data("alert-message"),
                        showCancelButton: true,
                        confirmButtonText: 'Si',
                        cancelButtonText: 'No',
                        icon: 'info',
                        confirmButtonColor: 'let(--vz-warning)',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Confirm.ActionYes_ItemClick(_confirmOptions);
                        }
                    });
                });
            });
            _selettore.find('[data-gruppo]').each(function () {
                let _this = $(this);
                let _gruppo: string = _this.data("gruppo");

                if (_gruppo !== null) {
                    $(`[data-gruppo-id="${_gruppo}"]`).children().prop("disabled", !_this.is(":checked"));
                }
            });
            _selettore.find("[data-charm]").each(function () {
                $(this).on("click", function (e) {
                    e.preventDefault();
                    $(this).tooltip("hide");
                    let _charmOptions: FormAside.CharmOptions = new FormAside.CharmOptions;

                    _charmOptions.Url = $(this).data("charm-url");
                    _charmOptions.Titolo = $(this).data("charm-titolo");
                    if ($(this).data("charm-dimensione") != undefined)
                        _charmOptions.Dimensione = $(this).data("charm-dimensione");

                    FormAside.Load(_charmOptions);
                });
            });
            _selettore.find('[data-spin]').each(function () {
                let _this = $(this);

                let _options: TouchSpinOptions = {
                    initval: 0,
                    min: _this.data("spin-min"),
                    max: _this.data("spin-max"),
                    step: _this.data("spin-step"),
                    decimals: _this.data("spin-decimal"),
                    prefix: _this.data("spin-prefix"),
                    postfix: _this.data("spin-postfix"),
                    prefix_extraclass: _this.data("spin-preclass"),
                    postfix_extraclass: _this.data("spin-postclass"),
                    buttondown_class: _this.data("spin-btndclass"),
                    buttonup_class: _this.data("spin-btnuclass"),
                    verticalbuttons: _this.data("spin-vertical")
                }

                _this.TouchSpin(_options);
            });

            _selettore.find('[data-toggle="tooltip"]').each(function () {
                $(this).tooltip(_settings_ToolTip);
            });

            _selettore.find('[data-tipo="data"]').each(function () {
                let _formato = $(this).data("tipo-formato");

                if (!$(this).prop('readonly')) {
                    (<any>$(this)).datetimepicker({
                        parentID: BodyName,
                        dayOfWeekStart: 1,
                        format: _formato,
                        step: 5,
                        timepicker: false,
                        timepickerScrollbar: false,
                        scrollMonth: false,
                        scrollTime: false,
                        scrollInput: false
                    });
                }
            });
            _selettore.find('[data-tipo="ora"]').each(function () {
                let _formato = $(this).data("tipo-formato");

                if (!$(this).prop('readonly')) {
                    (<any>$(this)).datetimepicker({
                        parentID: BodyName,
                        dayOfWeekStart: 1,
                        format: _formato,
                        step: 5,
                        datepicker: false,
                        timepickerScrollbar: false,
                        scrollMonth: false,
                        scrollTime: false,
                        scrollInput: false
                    });
                }
            });
            _selettore.find('[data-tipo="dataora"]').each(function () {
                let _formato = $(this).data("tipo-formato");

                if (!$(this).prop('readonly')) {
                    (<any>$(this)).datetimepicker({
                        parentID: BodyName,
                        dayOfWeekStart: 1,
                        format: _formato,
                        step: 5,
                        timepickerScrollbar: false,
                        scrollMonth: false,
                        scrollTime: false,
                        scrollInput: false
                    });
                }
            });
            _selettore.find('[data-tipo="decimale"]').each(function () {
                let _settings_AutoNumeric = {
                    createLocalList: false,
                    decimalCharacter: ",",
                    decimalPlaces: ($(this).data("num-decimali") != null ? $(this).data("num-decimali") : "8"),
                    digitGroupSeparator: ".",
                    outputFormat: "number",
                    selectOnFocus: false,
                    maximumValue: ($(this).data("num-massimo") != null ? $(this).data("num-massimo") : "1000000000000000"),
                    minimumValue: ($(this).data("num-minimo") != null ? $(this).data("num-minimo") : "0")
                };

                try {
                    new AutoNumeric(this, _settings_AutoNumeric);
                } catch (e) {
                    console.error("Error in decimal autonumeric: " + e);
                }
            });
            _selettore.find('[data-tipo="intero"]').each(function () {
                let _settings_AutoNumeric = {
                    createLocalList: false,
                    decimalCharacter: ",",
                    decimalPlaces: 0,
                    digitGroupSeparator: ".",
                    outputFormat: "number",
                    selectOnFocus: false,
                    maximumValue: ($(this).data("num-massimo") != null ? $(this).data("num-massimo") : "1000000000000000"),
                    minimumValue: ($(this).data("num-minimo") != null ? $(this).data("num-minimo") : "0")
                };

                try {
                    new AutoNumeric(this, _settings_AutoNumeric);
                } catch (e) {
                    console.error("Error in decimal autonumeric: " + e);
                }

            });
            _selettore.find('[data-tipo="fp"]').each(function () {
                let _this = $(this);
                let _listFiles: string[] = _this.data("fp-files");
                let _listFilesTypes: string[] = _this.data("fp-types");
                let _files = [];
                let _acceptedTypes = [];

                if (_listFiles != null) {
                    _listFiles.forEach(function (value) {
                        _files.push({
                            source: value,
                            options: { type: 'limbo' }
                        });
                    });
                }
                if (_listFilesTypes != null) {
                    _listFilesTypes.forEach(function (value) {
                        if (value.includes("zip")) {
                            _acceptedTypes.push("application/x-zip-compressed");
                        }
                        if (value.includes("spreadsheetml")) {
                            _acceptedTypes.push("application/vnd.ms-excel.sheet.macroEnabled.12");
                            _acceptedTypes.push("application/vnd.ms-excel.template.macroEnabled.12");
                            _acceptedTypes.push("application/vnd.ms-excel");
                            _acceptedTypes.push("application/vnd.openxmlformats-officedocument.spreadsheetml.template");
                        }
                        if (value.includes("wordprocessingml")) {
                            _acceptedTypes.push("application/msword");
                        }
                        _acceptedTypes.push(value);
                    });
                }

                (<any>$(this)).filepond({
                    name: _this.data("fp-nome"),
                    required: _this.data("fp-required"),
                    allowImagePreview: false,
                    allowMultiple: _this.data("fp-multiple"),
                    allowReorder: _this.data("fp-reorder"),
                    allowRevert: _this.data("fp-solalettura"),
                    credits: null,
                    maxFiles: _this.data("fp-maxfiles"),
                    allowFileSizeValidation: true,
                    minFileSize: _this.data("fp-minsize"),
                    maxFileSize: _this.data("fp-maxsize"),
                    labelIdle: _this.data("fp-testo"),
                    server: {
                        process: _this.data("fp-process"),
                        revert: _this.data("fp-revert"),
                        restore: _this.data("fp-restore"),
                    },
                    files: _files,
                    acceptedFileTypes: _acceptedTypes,
                });
            });
            _selettore.find('[data-tipo="switch"]').each(function () {
                (<any>$(this)).bootstrapToggle();
            });
            _selettore.find('[data-tipo="wysiwyg"]').each(function () {
                (<any>$(this)).summernote({
                    dialogsInBody: true,
                    dialogsFade: true,
                    disableDragAndDrop: false,
                    height: 600,
                    toolbar: [
                        ['style', ['style']],
                        ['font', ['bold', 'underline', 'italic', 'clear']],
                        ['para', ['ul', 'ol', 'paragraph', 'height']],
                        ['insert', ['hr']],
                        ['view', ['codeview', 'undo', 'redo']]
                    ],
                    callbacks: {
                        onInit: function () {
                            $('body > .note-popover').hide();
                        }
                    },
                });
            });

            _selettore.find('[data-tipo^="chart"]').each(function () {
                const globalChartOptions = new ChartsGlobal.BaseChart();
                globalChartOptions.ChartId = $(this).data("chart-Id");
                globalChartOptions.ChartHeight = $(this).data("chart-height");
                globalChartOptions.DivIdValue = $(this).attr("id");
                globalChartOptions.DefaultLocal = $(this).data("chart-defaultlocal");
                globalChartOptions.DefaultRegion = $(this).data("chart-defaultregion");
                globalChartOptions.Colors = $(this).data("chart-colors");
                globalChartOptions.Labels = $(this).data("chart-labels");
                globalChartOptions.Type = $(this).data("chart-type");
                globalChartOptions.PlotSize = $(this).data("chart-seizeplot");

                if ($(this).data("tipo") == "chartdonut") {//Donut chart
                    const donutOptions = new Donut.ChartOptions(globalChartOptions);
                    donutOptions.TotalLabel = $(this).data("chart-totallabel");
                    donutOptions.FunctionValue = $(this).data("chart-functionvalue");
                    donutOptions.FunctionTotal = $(this).data("chart-functiototal");
                    donutOptions.Series = $(this).data("chart-series");
                    Donut.Render(donutOptions);

                } else if ($(this).data("tipo") == "chartbar") {//Bar chart
                    const barChartOptions = new Bar.ChartOptions(globalChartOptions);
                    barChartOptions.MaxStepsValue = $(this).data("chart-maxsteps");
                    barChartOptions.Series = $(this).data("chart-datacol");
                    Bar.Render(barChartOptions);

                } else if ($(this).data("tipo") == "chartmixed") {//Mixed chart
                    const mixedChartOptions = new Mixed.ChartOptions(globalChartOptions);
                    mixedChartOptions.BarHeight = $(this).data("data-chart-barheight");
                    mixedChartOptions.Series = $(this).data("chart-datacol");
                    mixedChartOptions.MaxStepsValue = $(this).data("chart-maxsteps");
                    Mixed.Render(mixedChartOptions);
                } else if ($(this).data("tipo") == "chartarea") {//Area chart
                    const areaChartOptions = new Area.ChartOptions(globalChartOptions);
                    areaChartOptions.Series = $(this).data("chart-series");
                    areaChartOptions.Categories = $(this).data("chart-categories");
                    Area.Render(areaChartOptions);

                }
            });

            _selettore.find('[data-cstab-link]').each(function () {
                //data-cstab-link = link tab
                //data-cstab-target = nome panel attivare
                //data-cstab-name = nome del pannello
                //data-cstab-group = gruppo di tab
                $(this).on("click", function () {
                    let _this: JQuery<HTMLElement> = $(this);
                    let _group: string = _this.data("cstab-group");
                    let _panel: string = _this.data("cstab-target");

                    $(`[data-cstab-group="${_group}"][data-cstab-link]`).removeClass("active");
                    _this.addClass("active");

                    $(`[data-cstab-group="${_group}"][data-cstab-name]`).hide();
                    $(`[data-cstab-group="${_group}"][data-cstab-name="${_panel}"]`).fadeIn();
                });
            });
            _selettore.find("[data-help-id]").each(function () {
                $(this).on("click", function (e) {
                    e.preventDefault();
                    $(this).tooltip("hide");

                    let _charmOptions: FormAside.CharmOptions = new FormAside.CharmOptions;

                    _charmOptions.Url = UrlHelp;
                    _charmOptions.UrlData = { id: $(this).data("help-id") };
                    _charmOptions.Titolo = "Help - " + $(this).text();
                    _charmOptions.Dimensione = FormAside.CharmDimensions.Medium;

                    FormAside.LoadSecondary(_charmOptions);
                });
            });
            _selettore.find("[data-helpadmin-id]").each(function () {
                $(this).on("click", function (e) {
                    e.preventDefault();
                    $(this).tooltip("hide");

                    let _charmOptions: FormAside.CharmOptions = new FormAside.CharmOptions;

                    _charmOptions.Url = UrlResourceAdmin;
                    _charmOptions.UrlData = { id: $(this).data("helpadmin-id") };
                    _charmOptions.Titolo = "Help - " + $(this).text();
                    _charmOptions.Dimensione = FormAside.CharmDimensions.Medium;

                    FormAside.LoadSecondary(_charmOptions);
                });
            });

            _selettore.find(".input-validation-error").each(function () {
                $(this).removeClass(".input-validation-error").addClass("is-invalid");
            });

            _selettore.find(".contatore-valore").each(function () {
                let counter = $(this);
                let speed = 250; // The lower the slower
                counter &&
                    Array.from(counter).forEach(function (counter_value) {
                        function updateCount() {
                            let target = +counter_value.getAttribute("data-target");
                            let count = +counter_value.innerText;
                            let inc = target / speed;
                            if (inc < 1) {
                                inc = 1;
                            }
                            // Check if target is reached
                            if (count < target) {
                                // Add inc to count and output in counter_value
                                counter_value.innerText = (count + inc).toFixed(0);
                                // Call function every ms
                                setTimeout(updateCount, 1);
                            } else {
                                counter_value.innerText = numberWithCommas(target);
                            }
                            numberWithCommas(counter_value.innerText);
                        }
                        updateCount();
                    });

                function numberWithCommas(x) {
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
            });

            $.validator.unobtrusive.parse(context);
        }

        // YYYYYYYYYYYYYYYYYYYYYYYYYY Utile per creare il datapicker con onselectEvent
        export function executeFunctionByName(functionName, context /*, args */) {
            let args = Array.prototype.slice.call(arguments, 2);
            let namespaces = functionName.split(".");
            let func = namespaces.pop();
            for (const element of namespaces) {
                context = context[element];
            }

            return context[func](...args);
        }
        export function GetChartColorsArray(colors) {
            return colors.map(function (value) {
                let newValue = value.replace(" ", "");
                if (newValue.indexOf(",") === -1) {
                    let color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
                    if (color) return color;
                    else return newValue;
                } else {
                    let val = value.split(',');
                    if (val.length == 2) {
                        let rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
                        rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
                        return rgbaColor;
                    } else {
                        return newValue;
                    }
                }
            });
        }
        export function GetChartColor(color) {
            return getComputedStyle(document.documentElement).getPropertyValue(color);
        }

        export function ParseDateString(itDate: string): Date {
            const [day, month, year] = itDate.split('/').map(Number);
            return new Date(year, month - 1, day, 0, 0, 0, 0);
        }
        export function GetDateOfISOWeek(week: number, year: number) {
            const simple = new Date(year, 0, 1 + (week - 1) * 7); // Primo tentativo: settimana * 7 giorni
            const dayOfWeek = simple.getDay(); // Giorno della settimana (0 = Domenica, 1 = Lunedì, ecc.)
            const ISOweekStart = simple;

            if (dayOfWeek <= 4) {
                // Se il giorno è Lunedì-Martedì-Mercoledì-Giovedì
                ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
            } else {
                // Se il giorno è Venerdì-Sabato-Domenica
                ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
            }

            return ISOweekStart;
        }
        export function GetLastDayOfMonth(year: number, month: number): number {
            // Nota: i mesi sono indicizzati da 0 (gennaio = 0, dicembre = 11)
            return new Date(year, month + 1, 0).getDate();
        }

        //Effettua un fadeIn/Fadeout per una sostituzione
        export function fadeOutFadeIn(selector: JQuery<HTMLElement>, callback?: () => void, animationDuration: number | null = 200): void {
            $(selector).fadeOut(animationDuration, "swing", function () {
                callback?.();
                $(selector).fadeIn(animationDuration);
            });
        }

        //Metodo usato per il funzionamento del + e - per il contatore quantità
        export function ActivateNumberPlusMinusPicker(selector?: JQuery<HTMLElement | NodeList>) {
            let numberSelector = $('.plus, .minus')
            if (selector) {
                numberSelector = selector.find('.plus, .minus');
            }
            numberSelector.on('click', function () {
                const $button = $(this);
                const $input = $button.hasClass('plus')
                    ? $button.prev('input')
                    : $button.next('input');

                let value = parseInt($input.val() as string) || 0;
                const min = parseInt($input.attr('min')) || 0;
                const max = parseInt($input.attr('max')) || 999;

                if ($button.hasClass('plus') && value < max) {
                    $input.val(value + 1);
                }

                if ($button.hasClass('minus') && value > min) {
                    $input.val(value - 1);
                }

                $input.trigger('change'); // se serve intercettare il cambiamento
            });
        }

        //Oggetto base usato per le risposte JSON
        export class BaseJSONResponse {
            IsSuccess: boolean;
            Message: string;
        }

        export function GenerateAvatar(text, foregroundColor, backgroundColor) {
            var _split = text.split(' ');

            if (_split.length > 1) {
                text = _split[0].charAt(0);
                text += _split[1].charAt(0);
            } else {
                text = _split[0].charAt(0);
                text += _split[0].charAt(1);
            }

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            canvas.width = 250;
            canvas.height = 250;

            context.fillStyle = backgroundColor;
            context.fillRect(0, 0, canvas.width, canvas.height);

            context.font = "bold 100px Arial";
            context.fillStyle = foregroundColor;
            context.textAlign = "center";
            context.textBaseline = "middle";
            context.fillText(text.toUpperCase(), canvas.width / 2, canvas.height / 2);

            return canvas.toDataURL("image/png");
        }

        export function StartExportFileAjax($btn: JQuery<HTMLElement>, endpoint: string, data: any | null = null) {
            const originalHtml = $btn.html();

            $btn.html('<i class="fa-duotone fa-regular fa-spinner-third fa-spin"></i> Export...').prop("disabled", true);

            Swal.fire({
                title: "Export in corso...",
                text: "Stiamo generando il file, attendere.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.ajax({
                url: endpoint,
                type: "POST",
                data: data,
                xhrFields: { responseType: "blob" },
                success: function (blob, status, xhr) {
                    const disposition = xhr.getResponseHeader("Content-Disposition") || "";
                    let filename: string | null = null;

                    const utf8FileNameMatch = disposition.match(/filename\*=UTF-8''([^;\n]*)/i);
                    if (utf8FileNameMatch != null && utf8FileNameMatch[1]) {
                        filename = decodeURIComponent(utf8FileNameMatch[1]);
                    } else {
                        const asciiFileNameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
                        if (asciiFileNameMatch != null && asciiFileNameMatch[1]) {
                            filename = asciiFileNameMatch[1].replace(/['"]/g, "");
                        }
                    }

                    if (!filename) {
                        Swal.fire({
                            icon: "error",
                            title: "Errore export",
                            text: "Nome file non ricevuto dal server."
                        });
                        return;
                    }

                    const downloadUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(downloadUrl);

                    Swal.fire({
                        icon: "success",
                        title: "Export completato",
                        text: "Il file è stato scaricato correttamente."
                    });
                },
                error: function () {
                    Swal.fire({
                        icon: "error",
                        title: "Errore export",
                        text: "Si è verificato un errore durante la generazione del file."
                    });
                },
                complete: function () {
                    $btn.html(originalHtml).prop("disabled", false);
                }
            });
        }
    }
}

//------------Bootstrap Validazione------------------

(function ($) {
    let defaultOptions = {
        onkeyup: false,
        validClass: 'is-valid',
        errorClass: 'is-invalid',
        highlight: function (element, errorClass, validClass) {
            $(element)
                .removeClass(validClass)
                .addClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element)
                .removeClass(errorClass)
                .addClass(validClass);
        },
        errorPlacement: function (error, element) {
            let _nome: string = $(element).attr('id');
            let _element = $(element);
            let _error = $(error);

            let _tooltip = bootstrap.Tooltip.getInstance(`#${_nome}`);
            if (_tooltip != null)
                _tooltip.dispose();

            if (_error.text() != '') {
                if (_element.data("bs-title") != undefined)
                    _element.data("bs-title", _error.text());
                else
                    _element.attr('data-bs-title', _error.text());

                _tooltip = new bootstrap.Tooltip(`#${_nome}`);
            }
        },
        success: function (label, element) {
            let _tooltip = bootstrap.Tooltip.getInstance(`#${$(element).attr('id')}`);
            if (_tooltip != null)
                _tooltip.dispose();
        }
    };

    $.validator.setDefaults(defaultOptions);

    (<any>$.validator.unobtrusive).options = {
        errorClass: defaultOptions.errorClass,
        validClass: defaultOptions.validClass,
        errorPlacement: defaultOptions.errorPlacement,
        success: defaultOptions.success,
    };
})(jQuery);
